import { makeStyles, createStyles } from '@material-ui/core/styles';
import theme from 'styles/theme';

const useStyles = makeStyles(() =>
  createStyles({
    label: {
      fontWeight: 600,
      marginLeft: 5,
    },
    input: {
      marginBottom: 10,
      marginTop: 10,
      padding: 10,
      backgroundColor: '#F8F8FC',
      color: theme.palette.grey[300],
      width: '100%',
      fontSize: 16,
      textTransform: 'capitalize',
      borderRadius: 10,
      fontWeight: 'normal',
      height: 48,
      border: '1px solid #EBECF4',
      '&:before': {
        borderBottom: 'none',
      },
      '&:after': {
        width: '80%',
        border: 'none',
        borderRadius: 5,
      },
      '&& .MuiInput-underline:hover:not(.Mui-disabled):before': {
        border: 'none',
      },
    },
  }),
);

export default useStyles;
